// FarmaciaList.js
import React from 'react';
import FarmaciaItem from './FarmaciaItem';

function FarmaciaList({ farmacias, regionSeleccionada }) {
  const farmaciasFiltradas = regionSeleccionada
    ? farmacias.filter(farmacia => farmacia.fk_region === regionSeleccionada)
    : farmacias;

  return (
    <div>
      {farmaciasFiltradas.map((farmacia, index) => (
        <FarmaciaItem key={index} farmacia={farmacia} />
      ))}
    </div>
  );
}

export default FarmaciaList;
